"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const maplibre_gl_1 = require("maplibre-gl");
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const i18n_config_1 = __importDefault(require("chaire-lib-frontend/lib/config/i18n.config"));
const OctaviRouter_1 = __importDefault(require("./components/routers/OctaviRouter"));
const TransitionMainMap_1 = __importDefault(require("transition-frontend/lib/components/map/TransitionMainMap"));
const configureStore_1 = __importDefault(require("chaire-lib-frontend/lib/store/configureStore"));
const pages_1 = require("chaire-lib-frontend/lib/components/pages");
const project_config_1 = __importDefault(require("chaire-lib-frontend/lib/config/project.config"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const application_config_1 = require("chaire-lib-frontend/lib/config/application.config");
const verifyAuthentication_1 = __importDefault(require("chaire-lib-frontend/lib/services/auth/verifyAuthentication"));
const ThemeContext_1 = require("chaire-lib-frontend/lib/contexts/ThemeContext");
require("chaire-lib-frontend/lib/styles/styles-transition.scss");
require("./styles/styles-octavi.scss");
const OctaviDashboardContributions_1 = require("./components/dashboard/OctaviDashboardContributions");
// MapLibre 6 loads the tile worker with `new Worker(url, { type: 'module' })`.
// https://maplibre.org/maplibre-gl-js/docs/guides/v5-to-v6-migration-guide/
// Webpack copies the worker file to /dist: the frontend is compiled to CommonJS, so the
// `new URL(..., import.meta.url)` pattern of the MapLibre webpack documentation is not available.
// The file name is the same in every release, so the version keeps browsers from using an old cached worker.
// This must run before the first map.
(0, maplibre_gl_1.setWorkerUrl)(`/dist/maplibre-gl-worker.mjs?v=${(0, maplibre_gl_1.getVersion)()}`);
(0, application_config_1.setApplicationConfiguration)({
    homePage: '/dashboard',
    userMenuItems: [
        {
            getText: (t) => t('main:Preferences'),
            action: () => ServiceLocator_1.default.eventManager.emit('section.change', 'preferences', false)
        }
    ]
});
// Set the application title for the header
// TODO This is a frontend only configuration, that should be configured in code, not in the config file. When configuration objects are revisited, make sure that is clear and possible
project_config_1.default.appTitle = 'Octavi';
const store = (0, configureStore_1.default)();
const contributions = [new OctaviDashboardContributions_1.OctaviDashboardContribution()];
const jsx = (react_1.default.createElement(react_redux_1.Provider, { store: store },
    react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_config_1.default },
        react_1.default.createElement(ThemeContext_1.ThemeProvider, null,
            react_1.default.createElement(react_router_1.BrowserRouter, null,
                react_1.default.createElement(OctaviRouter_1.default, { contributions: contributions, mainMap: TransitionMainMap_1.default }))))));
const root = (0, client_1.createRoot)(document.getElementById('app'));
root.render(react_1.default.createElement(pages_1.LoadingPage, null));
let hasRendered = false;
const renderApp = () => {
    if (!hasRendered) {
        root.render(jsx);
        hasRendered = true;
    }
};
(0, verifyAuthentication_1.default)(store.dispatch).finally(() => renderApp());
//# sourceMappingURL=app-octavi.js.map